import Navbar from "@/components/optify/Navbar";
import HeroSection from "@/components/optify/HeroSection";
import AIAssistantSection from "@/components/optify/AIAssistantSection";
import AICallsSection from "@/components/optify/AICallsSection";
import MarketingSection from "@/components/optify/MarketingSection";
import ModulesSection from "@/components/optify/ModulesSection";
import CaseStudySection from "@/components/optify/CaseStudySection";
import PricingSection from "@/components/optify/PricingSection";
import CtaSection from "@/components/optify/CtaSection";
import Footer from "@/components/optify/Footer";
import { Seo } from "@/i18n/Seo";
import { useDict } from "@/i18n/useDict";

const Index = () => {
  const { dict } = useDict();
  return (
    <div className="min-h-screen bg-background">
      <Seo path="/" title={dict.seo.home.title} description={dict.seo.home.description} />
      <Navbar />
      <HeroSection />
      <AIAssistantSection />
      <AICallsSection />
      <MarketingSection />
      <ModulesSection />
      <CaseStudySection />
      <PricingSection />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Index;
